// extracted by mini-css-extract-plugin
module.exports = {"EmptyCard":"EmptyCard_EmptyCard__sLltN","EmptyCardIcon":"EmptyCard_EmptyCardIcon__AGI_5"};